import { Pencil, FileText } from 'lucide-react';
import { useSelector } from 'react-redux';
import { Button } from '@/components/ui/Button';
import { Badge } from '@/components/ui/badge';
import { DetailRow, CollapseSection } from '@/components/ui/DetailSection';
import Bar from '@/components/elements/Bar';
import { ProductDetailViewProps } from '../types';
import ApprovalItemActions from '@/features/approval/components/ApprovalItemActions';

const ProductDetailView = ({ data, onEdit, editDisable }: ProductDetailViewProps) => {
  const permission = editDisable ? 0 : useSelector((state: any) => state.auth.pagePermission);

  const files = data?.files || [];

  const renderLink = (value?: string | null) =>
    value ? (
      <a
        href={value}
        target="_blank"
        rel="noreferrer"
        className="text-primary-600 hover:underline break-all"
      >
        {value}
      </a>
    ) : (
      '—'
    );

  return (
    <div className="flex-1 overflow-y-auto bg-neutral-25/30">
      <Bar
        text="Detail"
        content={
          permission === 2
            ? [
                <Button
                  key={1}
                  variant="ghost"
                  size="icon-sm"
                  onClick={onEdit}
                  data-testid="product-detail-edit-btn"
                >
                  <Pencil />
                </Button>,
              ]
            : undefined
        }
      />
      <ApprovalItemActions objectType="product" objectId={data?.id} status={data?.status} />
      <div className="px-6">
        <div className="py-5 space-y-3 border-b border-neutral-150">
          <DetailRow label="Označení" value={data?.title || ''} />
          <DetailRow label="Web" value={renderLink(data?.url)} />
          <DetailRow label="Datasheet" value={renderLink(data?.datasheet_url)} />
          <DetailRow label="Popis" value={data?.description || '—'} />
          <DetailRow label="Výrobce" value={data?.manufacturer?.title || '—'} />
          <DetailRow
            label="Konzultant"
            value={
              data?.consultant
                ? `${data.consultant.first_name} ${data.consultant.last_name}`.trim()
                : '—'
            }
          />
          <DetailRow
            label="Stav"
            value={
              <Badge variant={data?.is_active ? 'success' : 'default'} size="sm">
                {data?.is_active ? 'Aktivní' : 'Neaktivní'}
              </Badge>
            }
          />
        </div>

        <CollapseSection title="Soubory" badge={files.length} defaultOpen={files.length > 0}>
          <div className="space-y-2 mt-2">
            {files.map((file: any, i: number) => (
              <a
                key={file.id || i}
                href={file.url}
                target="_blank"
                rel="noreferrer"
                className="px-3 py-2 bg-white border border-neutral-150 rounded flex items-center gap-2 hover:border-primary-300 transition-colors"
              >
                <FileText size={14} className="text-neutral-500" />
                <span className="text-sm text-neutral-800">{file.title}</span>
              </a>
            ))}
          </div>
        </CollapseSection>
      </div>
    </div>
  );
};

export default ProductDetailView;
